export const f8Grey = '#F8F8F8'
export const f2Grey = '#F2F2F2'
export const e0Grey = '#E0E0E0'
export const d9Grey = '#D9D9D9'

export const formText = 'rgba(0,0,0,0.6)'

export const facebook = '#4267B2'
export const instagram = '#C13584'
export const facebookCallToActionButtonGrey = '#1c1e21'
